import React, { useContext } from 'react';
import CanvasContext from '../../../context/CanvasContext';
import styles from '../styles/AdminCanvasSidebar.module.css';

/**
 * Shows the text of whichever node an admin has selected.
 *
 * The text comes from the node itself — under the draft model `node.data` holds
 * the authoring fields, so there is no separate situation list to look through
 * (and no crash when the id is not in it, which the old lookup did not guard).
 */
const AdminCanvasSidebar = ({ onClose }) => {
    const { adminSelectedNode, getNode } = useContext(CanvasContext);

    const text = adminSelectedNode ? getNode(adminSelectedNode.id)?.data?.text : null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContainer}>
                {text ? <div dangerouslySetInnerHTML={{ __html: text }} /> : <div>No text</div>}
            </div>
            <button onClick={onClose} className={styles.closeButton}>
                ×
            </button>
        </div>
    );
};

export default AdminCanvasSidebar;
